exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/project-order-summary/tasks-icons/tasks-icons.component.scss
// module id = ../../../../../src/app/dashboard-my-oasis/project-order-summary/tasks-icons/tasks-icons.component.scss
// module chunks = main